import Services from 'services'

class PeluangApi {
    get(params) {
        return Services.get('approval_peluang/list/', { params })
    }

    getHistory(params) {
        return Services.get('approval_peluang/history/', { params })
    }

    getSingle(params) {
        return Services.get('approval_peluang/detail', { params })
    }

    getAnalisa(params) {
        return Services.get('approval_peluang/analisa_barang_jadi_single', { params })
    }

    approve(data) {
        return Services.post('approval_peluang/approve', data)
    }
}

export default new PeluangApi()